import { render, staticRenderFns } from "./Orderarea.vue?vue&type=template&id=049253f6&scoped=true"
import script from "./Orderarea.vue?vue&type=script&lang=js"
export * from "./Orderarea.vue?vue&type=script&lang=js"
import style0 from "./Orderarea.vue?vue&type=style&index=0&id=049253f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049253f6",
  null
  
)

export default component.exports